const mul_session_type_list = [
  { id: "session_1", value: "session1", config: "session1", label: "mul_session1" },
  { id: "session_2", value: "session2", config: "session2", label: "mul_session2" },
];

const mode_list = [
  { id: "skeyword_never", value: "never", config: "never", label: "never_mark" },
  { id: "skeyword_sched", value: "schedule", config: "schedule", label: "per_schedule_mark" },
  { id: "skeyword_always", value: "always", label: "always_mark", config: "always" },
];

const service_list = [
  {
    value: "User_Defined",
    config: "User_Defined",
    label: "block_ser_setup_userdefined",
    proto: "",
    start_port: "",
    end_port: "",
  },
  {
    value: "Any",
    label: "any",
    config: "Any",
    proto: "TCP/UDP",
    start_port: "1",
    end_port: "65535",
  },
  {
    value: "Any(TCP)",
    label: "block_ser_setup_anyTCP",
    config: "Any(TCP)",
    proto: "TCP",
    start_port: "1",
    end_port: "62235",
  },
  {
    value: "Any(UDP)",
    label: "block_ser_setup_anyUDP",
    config: "Any(UDP)",
    proto: "UDP",
    start_port: "1",
    end_port: "65535",
  },
  {
    value: "AIM",
    label: "block_ser_setup_aim",
    config: "AIM",
    proto: "TCP",
    start_port: "5190",
    end_port: "5190",
  },
  {
    value: "Age-of-Empire",
    label: "block_ser_setup_age",
    config: "Age-of-Empire",
    proto: "UDP",
    start_port: "47624",
    end_port: "47624",
  },
  {
    value: "BGP",
    label: "block_ser_setup_bgp",
    config: "BGP",
    proto: "TCP",
    start_port: "179",
    end_port: "179",
  },
  {
    value: "BOOTP-CLIENT",
    label: "block_ser_setup_bootclient",
    config: "BOOTP-CLIENT",
    proto: "UDP",
    start_port: "68",
    end_port: "68",
  },
  {
    value: "BOOTP-SERVER",
    label: "block_ser_setup_bootserver",
    config: "BOOTP-SERVER",
    proto: "UDP",
    start_port: "67",
    end_port: "67",
  },
  {
    value: "CU-SEEME",
    label: "block_ser_setup_cuseeme",
    config: "CU-SEEME",
    proto: "TCP/UDP",
    start_port: "7648",
    end_port: "24032",
  },
  {
    value: "DNS",
    label: "block_ser_setup_dns",
    config: "DNS",
    proto: "TCP/UDP",
    start_port: "53",
    end_port: "53",
  },
  {
    value: "FINGER",
    label: "block_ser_setup_finger",
    config: "FINGER",
    proto: "TCP",
    start_port: "79",
    end_port: "79",
  },
  {
    value: "FTP",
    label: "block_ser_setup_ftp",
    config: "FTP",
    proto: "TCP",
    start_port: "20",
    end_port: "21",
  },
  {
    value: "H.323",
    label: "block_ser_setup_h323",
    config: "H.323",
    proto: "TCP",
    start_port: "1720",
    end_port: "1720",
  },
  {
    value: "HTTP",
    label: "block_ser_setup_http",
    config: "HTTP",
    proto: "TCP",
    start_port: "80",
    end_port: "80",
  },
  {
    value: "HTTPS",
    label: "block_ser_setup_https",
    config: "HTTPS",
    proto: "TCP",
    start_port: "443",
    end_port: "443",
  },
  {
    value: "ICUII",
    label: "block_ser_setup_icu",
    config: "ICUII",
    proto: "TCP",
    start_port: "23566",
    end_port: "23566",
  },
  {
    value: "IDENT",
    label: "block_ser_setup_ident",
    config: "IDENT",
    proto: "TCP",
    start_port: "113",
    end_port: "113",
  },
  {
    value: "IP_Phone",
    label: "block_ser_setup_ipphone",
    config: "IP_Phone",
    proto: "TCP",
    start_port: "6670",
    end_port: "6670",
  },
  {
    value: "IRC",
    label: "block_ser_setup_irc",
    config: "IRC",
    proto: "TCP/UDP",
    start_port: "6667",
    end_port: "6667",
  },
  {
    value: "NetMeeting",
    label: "block_ser_setup_netmeet",
    config: "NetMeeting",
    proto: "TCP",
    start_port: "1720",
    end_port: "1720",
  },
  {
    value: "NFS",
    label: "block_ser_setup_nfs",
    config: "NFS",
    proto: "UDP",
    start_port: "2049",
    end_port: "2049",
  },
  {
    value: "News",
    label: "block_ser_setup_news",
    config: "News",
    proto: "TCP",
    start_port: "119",
    end_port: "119",
  },
  {
    value: "QuakeII/III",
    label: "block_ser_setup_quake",
    config: "QuakeII/III",
    proto: "TCP/UDP",
    start_port: "27960",
    end_port: "27960",
  },
  {
    value: "RCMD",
    label: "block_ser_setup_rcmd",
    config: "RCMD",
    proto: "TCP",
    start_port: "512",
    end_port: "512",
  },
  {
    value: "Real-Audio",
    label: "block_ser_setup_real",
    config: "Real-Audio",
    proto: "TCP/UDP",
    start_port: "6970",
    end_port: "7170",
  },
  {
    value: "REXEC",
    label: "block_ser_setup_rexec",
    config: "REXEC",
    proto: "TCP",
    start_port: "514",
    end_port: "514",
  },
  {
    value: "RLOGIN",
    label: "block_ser_setup_rlogin",
    config: "RLOGIN",
    proto: "TCP",
    start_port: "513",
    end_port: "513",
  },
  {
    value: "RTELNET",
    label: "block_ser_setup_rtelnet",
    config: "RTELNET",
    proto: "TCP",
    start_port: "107",
    end_port: "107",
  },
  {
    value: "RTSP",
    label: "block_ser_setup_rtsp",
    config: "RTSP",
    proto: "TCP/UDP",
    start_port: "554",
    end_port: "554",
  },
  {
    value: "SFTP",
    label: "block_ser_setup_sftp",
    config: "SFTP",
    proto: "TCP",
    start_port: "115",
    end_port: "115",
  },
  {
    value: "SMTP",
    label: "block_ser_setup_smtp",
    config: "SMTP",
    proto: "TCP",
    start_port: "25",
    end_port: "25",
  },
  {
    value: "SNMP",
    label: "block_ser_setup_snmp",
    config: "SNMP",
    proto: "TCP/UDP",
    start_port: "161",
    end_port: "161",
  },
  {
    value: "SNMP_TRAPS",
    label: "block_ser_setup_snmptraps",
    config: "SNMP_TRAPS",
    proto: "TCP/UDP",
    start_port: "162",
    end_port: "162",
  },
  {
    value: "SQL-NET",
    label: "block_ser_setup_sqlnet",
    config: "SQL-NET",
    proto: "TCP",
    start_port: "1521",
    end_port: "1521",
  },
  {
    value: "SSH",
    label: "block_ser_setup_ssh",
    config: "SSH",
    proto: "TCP/UDP",
    start_port: "22",
    end_port: "22",
  },
  {
    value: "STRMWORKS",
    label: "block_ser_setup_strmworks",
    config: "STRMWORKS",
    proto: "UDP",
    start_port: "1558",
    end_port: "1558",
  },
  {
    value: "TACACS",
    label: "block_ser_setup_tacacs",
    config: "TACACS",
    proto: "UDP",
    start_port: "49",
    end_port: "49",
  },
  {
    value: "Telnet",
    label: "block_ser_setup_telnet",
    config: "Telnet",
    proto: "TCP",
    start_port: "23",
    end_port: "23",
  },
  {
    value: "TFTP",
    label: "block_ser_setup_tftp",
    config: "TFTP",
    proto: "UDP",
    start_port: "69",
    end_port: "69",
  },
  {
    value: "VDOLIVE",
    label: "block_ser_setup_vdolive",
    config: "VDOLIVE",
    proto: "TCP",
    start_port: "7000",
    end_port: "7000",
  },
  {
    value: "VPN-IPSEC",
    label: "block_ser_setup_vpn_ipsec",
    config: "VPN-IPSEC",
    proto: "UDP",
    start_port: "500",
    end_port: "500",
  },
  {
    value: "VPN-L2TP",
    label: "block_ser_setup_vpn_l2tp",
    config: "VPN-L2TP",
    proto: "UDP",
    start_port: "1701",
    end_port: "1701",
  },
  {
    value: "VPN-PPTP",
    label: "block_ser_setup_vpn_pptp",
    config: "VPN-PPTP",
    proto: "TCP",
    start_port: "1723",
    end_port: "1723",
  },
];
const proto_list = [
  { value: "TCP", config: "TCP", label: "block_ser_setup_tcp" },
  { value: "UDP", label: "block_ser_setup_udp", config: "UDP" },
  { value: "TCP/UDP", label: "block_ser_setup_tcp_udp", config: "TCP_UDP" },
];
const ip_addr_range_list = [
  { id: "filter_ip_single", value: "single", config: "single", label: "block_ser_setup_thisip" },
  {
    id: "filter_ip_range",
    value: "range_addr",
    config: "range_addr",
    label: "block_ser_setup_iprang",
  },
  { id: "filter_ip_all", value: "all", label: "block_ser_setup_allip", config: "any" },
];

export const blockServices = {
  mul_session_type: mul_session_type_list,
  mode: mode_list,
  service_type: service_list,
  proto: proto_list,
  ip_addr_range: ip_addr_range_list,
};

export default blockServices;
